import AsyncStorage from "@react-native-async-storage/async-storage"
import { DEMO_FLOW_ENABLED, roomControlPath } from "../../config/Constant";
import { roomControlFailure, roomControlSuccess, setRoomControlLoading } from "../Reducers/roomControlReducer";

const ROOM_CONTROL_DEMO = {
    "class": "com.inRoomControl.utils.ResponseWrapper",
    "header": {
        "status": {
            "code": "SUCCESS",
            "msg": "Request Successful."
        }
    },
    "payload": { 
		"configs": {
			"acUnitChangeViaServer": true,
			"farenheitMax": "84",
			"fanSpeedSupported": true,
			"fanSpeedConfig": [
				{
					"position": 1,
					"action": "setFanSpeedToLow",
					"label": "LOW"
				},
				{
					"position": 2,
					
					"action": "setFanSpeedToMedium",
					"label": "MEDIUM"
				},
				{
					"position": 3,
					
					"action": "setFanSpeedToHigh",
					"label": "HIGH"
				},
				{
					"position": 4,
					
					"action": "setFanSpeedToAuto",
					"label": "AUTO ON"
				},
				{
					"position": 5,
					"action": "setFanSpeedToAutoOff",
					"label": "AUTO OFF"
				}
			],
			"farenheitMin": "66",
			"celciusMax": "28",
			"celciusMin": "18"
		},
		
		"master": {
			"lights": [
				{
					"lights": [
						{
							"lightCode": "All lights",
							"lightLabel": "ALL LIGHTS"
						}
					],
					"lightsSubTypeLabel": ""
				}
			],
			"mur": [
				{
					"murSubTypeLabel": "",
					"mur": [
						{
							"murLabel": "Cleaning Mode on",
							"murCode": "cleaning_on"
						},
						{
							"murLabel": "Cleaning Mode off",
							"murCode": "cleaning_off"
						}
					]
				}
			],
			"dnd": [
				{
					"dndSubTypeLabel": "",
					"dnd": [
						{
							"dndLabel": "Do not disturb on",
							"dndCode": "do_not_disturb_on"
						}
					]
				}
			]
		},
        "data": [
			{
				"hvac": [{
					"temperatureValue": "+,25.5", 
					"currentRoomTemperature": "+,25.5", 
					"fanSpeed": "FAN_SPEED_LOW", 
					"isFanAuto": "false", 
					"temperatureUnit": "C",
					"mainSwitch": "ON"
				}],
				"label": "Living room",
				"code": "LR",
				"curtain": [{
					"curtainSubTypeLabel": "Curtains Control", 
					"curtain": [{
						"curtainCode": "livingroom_blinds_move_up", 
						"curtainLabel": "Livingroom curtain up"
					}, {
						"curtainCode": "livingroom_blinds_move_stop", 
						"curtainLabel": "Livingroom curtain stop"
					}]
				}]
			},
			{
				"lights": [
                    {
                        "lights": [
                            {
                                "lightIconImgUrl": "/cmsData/roomControl/icons/lights/ico-minus.svg",
                                "currentState": "OFF",
                                "lightCode": "SCENE_4_BV1",
                                "lightLabel": "Lounge Lower"
                            },
                            {
                                "lightIconImgUrl": "/cmsData/roomControl/icons/lights/ico-plus.svg",
                                "currentState": "OFF",
                                "lightCode": "SCENE_4_BV1",
                                "lightLabel": "Lounge Raise"
                            }
                        ],
                        "lightsSubTypeLabel": "Light Control"
                    },
					{
                        "lights": [
                            {
                                "lightIconImgUrl": "/cmsData/roomControl/icons/lights/ico-minus.svg",
                                "currentState": "OFF",
                                "lightCode": "SCENE_4_BV1",
                                "lightLabel": "Lounge Lower"
                            },
                            {
                                "lightIconImgUrl": "/cmsData/roomControl/icons/lights/ico-plus.svg",
                                "currentState": "OFF",
                                "lightCode": "SCENE_4_BV1",
                                "lightLabel": "Lounge Raise"
                            }
                        ],
                        "lightsSubTypeLabel": "Light Control"
                    }
                ],
                "hvac": [
                    {
                        "temperatureValue": "+,25",
                        "acLabel": "Wardrobe",
                        "fanSpeed": "FAN_SPEED_AUTO",
                        "temperatureUnit": "C",
                        "acMode": "AC_MODE_AUTO",
                        "HVACIdentifierKey": "HVAC"
                    },
                    {
                        "acLabel": "Living",
                        "HVACIdentifierKey": "HVAC"
                    }
                ],
                "label": "Bed Room",
                "code": "LR",
                "tvLift": [
                    {
                        "label": "Bedroom",
                        "VERTICAL": "",
                        "uniqueKey": "tvLift_bedroom"
                    }
                ],
                "curtain": [
                    {
                        "curtainSubTypeLabel": "Light Control",
                        "curtain": [
                            {
                                "curtainCode": "CURTAIN_4_BV1",
                                "currentState": "OFF",
                                "curtainLabel": "Curtain Lower",
                                "curtainIconImgUrl": "/cmsData/roomControl/icons/curtains/ico-minus.svg"
                            },
                            {
                                "curtainCode": "CURTAIN_4_BV1",
                                "currentState": "OFF",
                                "curtainLabel": "Curtain Raise",
                                "curtainIconImgUrl": "/cmsData/roomControl/icons/curtains/ico-plus.svg"
                            }
                        ]
                    },
					{
                        "curtainSubTypeLabel": "Light Control",
                        "curtain": [
                            {
                                "curtainCode": "CURTAIN_4_BV1",
                                "currentState": "OFF",
                                "curtainLabel": "Curtain Lower",
                                "curtainIconImgUrl": "/cmsData/roomControl/icons/curtains/ico-minus.svg"
                            },
                        ]
                    }
                ]
			}
		]
    }
}

export const getRoomControlData = () => {

    return async (dispatch, getState) => {
        try{
			dispatch(setRoomControlLoading(true));

            const room = await AsyncStorage.getItem("room");
            const deviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
            const sessionToken = await AsyncStorage.getItem('sessionToken');

            let locationId = getState().guestDetailsSlice?.currentGuestDetails?.location || "";
            if(DEMO_FLOW_ENABLED){
                dispatch(roomControlSuccess(ROOM_CONTROL_DEMO.payload));
                return;
            }
			
            const response = await roomControlPath.post(`/roomControl/zonesWiseData?dId=${deviceIdentifier}&rn=${room}`, {
                header: { sessionToken },
                payload: {
                    locationId,
                    "versionKey": "version2"
                },
            })
			if(response?.data?.header?.status?.code == "SUCCESS"){
				dispatch(roomControlSuccess(response.data.payload))
			}
        } catch (error){
            const response = error.response || {};
			const errorMessage = response.data?.header?.status?.msg || error.message || `Something went wrong`;


			console.log("Error message", errorMessage)
    
            dispatch(roomControlFailure(errorMessage))
        }

    }
}


export const sendAcCommand = (action, magnitude, definedCircuit, identifier, callBack=()=>{}) => {
  return async (dispatch, getState) => {
	try{
		const sessionToken = await AsyncStorage.getItem('sessionToken');
		let locationId = getState().guestDetailsSlice?.currentGuestDetails?.location || "";

		const response = await roomControlPath.post(`/roomControl`,{
			header: {
				sessionToken,
				locationId,
				action,
				identifier: identifier,
				versionKey: "version2"
			},
			payload: {
				magnitude: magnitude,
				definedCircuit: definedCircuit
			}
		})

		if(response?.data?.header?.status?.code == "SUCCESS"){
			callBack(true, response?.data?.header?.status?.msg);
		} else {
			callBack(false, response?.data?.header?.status?.msg);
		}

	} catch(error){
		const errorMessage = error?.response?.data?.header?.status?.msg || error?.message || "Something went wrong"
		callBack(false, errorMessage);
	}
  }
}

export const sendCommand = (code, controlInterface, section, callback=()=>{}) => {

  return async (dispatch, getState) => {
	try {
		const sessionToken = await AsyncStorage.getItem('sessionToken');
		let locationId = getState().guestDetailsSlice?.currentGuestDetails?.location || "";

		const isLutron = controlInterface?.interface == 'lutron';

		const response = await roomControlPath.post('/roomControl',{
			header: {
				sessionToken,
				locationId,
				action: isLutron ? controlInterface?.action : code,
				versionKey: "version2"
			},
			payload: {
				...(isLutron && {
					definedCircuit: (section == 'fanSpeed' || section == 'dnd' || section == 'mur') ? null : code,
					magnitude: (section == 'fanSpeed' || section == 'dnd' || section == 'mur')? null : code
				})
			}
		})
		if(response?.data?.header?.status?.code == "SUCCESS"){
			callback(true, response?.data?.header?.status?.msg);
		} else {
			callback(false, response?.data?.header?.status?.msg);
		}
	} catch (error) {
		const errorMessage = error?.response.data?.header?.status?.msg || error?.message || "Something went wrong";
		console.log(errorMessage)
		callback(false, errorMessage)
	}
  }
}



export const fahrenheitToCelsius = (temp, min, max) => {
	let newTemp = ((temp - 32) * 0.5556).toFixed(0);
	if(newTemp<min) newTemp=min;
	else if( newTemp>max) newTemp=max;

	return newTemp <= 0 ? 0 : newTemp >= 100 ? 100 : newTemp;;
}

export const celsiusToFahrenheit = (temp, min, max) => {
	let newTemp = ((temp * 1.8) + 32).toFixed(0);

	if(newTemp<min) newTemp=min;
	else if( newTemp>max) newTemp=max;

	return newTemp <= 32 ? 32 : newTemp >= 212 ? 212 : newTemp;
}
